import { render, staticRenderFns } from "./FriendTablePanel.vue?vue&type=template&id=06b4fb3c&scoped=true"
import script from "./FriendTablePanel.vue?vue&type=script&lang=js"
export * from "./FriendTablePanel.vue?vue&type=script&lang=js"
import style0 from "./FriendTablePanel.vue?vue&type=style&index=0&id=06b4fb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4fb3c",
  null
  
)

export default component.exports